import React from 'react'
import { StyleSheet, css } from 'aphrodite'

// MATERIAL UI STUFF
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import SvgIcon from '@material-ui/core/SvgIcon'
import Tooltip from '@material-ui/core/Tooltip'


export default class SimpleParagraphWButtonGrey extends React.Component {
	render(){
		return(
			<div className="MainDiv">
				<Typography color="secondary" style={{opacity: 1}} gutterBottom variant="display1" style={{ fontWeight: 500, }}>{this.props.title}</Typography>
                <Typography color="secondary" style={{opacity: .6}} gutterBottom variant="headline" style={{ fontWeight: 500, lineHeight: '1.2em'}}>{this.props.subtitle}</Typography>
                <Typography color="secondary" style={{opacity: .6}} variant="subheading">{this.props.text}</Typography>
                <MainButton /> 
			</div>
			)
	}
}

const MainButton = () =>
<Tooltip title="Available soon" placement="bottom">
	<Button className={css(styles.introButton)}>
        <Grid style={{marginLeft: 20}} container direction="row" alignItems="center" justify="space-between">
            <Grid item>
            Meet Us
            </Grid>
                <Grid item>
                    <SvgIcon className={css(styles.rightArrow)}>
                        <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/>
                    </SvgIcon> 
                </Grid>
        </Grid>
    </Button>
    </Tooltip>


const styles = StyleSheet.create({
    introButton: {
        color: 'white',
        width: 180,
        background: 'linear-gradient(-161deg, #4D88FF, #457FDD)',
        borderRadius: 200,
        lineHeight: 0,
        paddingRight: '10px',
        marginTop: '5%',
     	boxShadow: '0 18px 35px rgba(50,50,93,.1), 0 8px 15px rgba(0,0,0,.07)',
        transition: 'all ease-in-out .2s',
        ':hover':{
            transform: 'translate(0, -2px)',
            boxShadow: '0 20px 40px rgba(50,50,93,.2), 0 8px 15px rgba(0,0,0,.07)',
        }
    },
    rightArrow: {
        backgroundColor: '#F7FCFF',
        color: '#457FDD',
        borderRadius: '188px',
        fontSize: '31px',
        padding: '5px',
        marginLeft: '15px'
    }
});


// WEBPACK FOOTER //
// ./src/Components/Utilities/SimpleParagraphWButtonGrey.js